"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _Title = _interopRequireDefault(require("@airasia/phoenix-components/components/Title"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _constant = require("@airasia/phoenix-components/components/Title/constant");

var _constant2 = require("@airasia/phoenix-components/components/Text/constant");

var _showAllTiles = _interopRequireDefault(require("./show.all.tiles.proptypes"));

var _constants = require("./constants");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var TextWrapperDesktop = _styledComponents.default.div.withConfig({
  displayName: "ShowAllTiles__TextWrapperDesktop",
  componentId: "sc-sryk9t-0"
})(["padding:", " ", " ", " ", ";color:", ";"], _constants.DESKTOP_PADDING.TOP, _constants.DESKTOP_PADDING.RIGHT, _constants.DESKTOP_PADDING.BOTTOM, _constants.DESKTOP_PADDING.LEFT, function (props) {
  return props.theme.colors.greyDark;
});

var TextWrapperMobile = _styledComponents.default.div.withConfig({
  displayName: "ShowAllTiles__TextWrapperMobile",
  componentId: "sc-sryk9t-1"
})(["display:flex;align-items:center;justify-content:space-between;padding:", " ", " ", " ", ";"], _constants.MOBILE_PADDING.TOP, _constants.MOBILE_PADDING.RIGHT, _constants.MOBILE_PADDING.BOTTOM, _constants.MOBILE_PADDING.LEFT);

var DesktopInnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "ShowAllTiles__DesktopInnerWrapper",
  componentId: "sc-sryk9t-2"
})(["display:grid;width:100%;margin:0 auto;grid-template-columns:repeat(", ",", ");padding-bottom:", ";grid-gap:1px;", " ", ""], function (props) {
  return props.repeat;
}, _constants.WIDTH, _constants.WRAPPER_PADDING, function (props) {
  return props.isIE && (0, _styledComponents.css)(["display:flex;flex-wrap:wrap;", "{width:200px;}"], props.otherTileSelector);
}, function (props) {
  return props.tileItemFlexDirection === 'column' && (0, _styledComponents.css)(["> div > div{min-height:100px;min-width:100px;}"]);
});

var MobileInnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "ShowAllTiles__MobileInnerWrapper",
  componentId: "sc-sryk9t-3"
})(["display:grid;grid-template-columns:auto auto auto auto;justify-items:center;grid-row-gap:", ";", ""], _constants.GRID_ROW_GAP, function (props) {
  return props.tileItemFlexDirection === 'column' && (0, _styledComponents.css)(["> div > div{min-height:100px;}"]);
});

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "ShowAllTiles__Wrapper",
  componentId: "sc-sryk9t-4"
})(["width:95%;margin:0 auto;"]);

var ShowAllTiles = function ShowAllTiles(props) {
  var dataArray = props.dataArray,
      headingDesktop = props.headingDesktop,
      headingMobile = props.headingMobile,
      isMobile = props.isMobile,
      theme = props.theme,
      isIE = props.isIE,
      otherTileSelector = props.otherTileSelector,
      tileItemFlexDirection = props.tileItemFlexDirection;
  var wrapperRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(3),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      repeat = _useState2[0],
      setRepeat = _useState2[1];

  var iconProperties = {
    'data-icon': 'close-icon'
  };
  (0, _react.useEffect)(function () {
    if (!isMobile && wrapperRef) {
      setRepeat(Math.floor(parseInt(wrapperRef.current.offsetWidth, 10) / 200));
    }
  }, [isMobile]);
  return !isMobile ? /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(TextWrapperDesktop, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: _constant2.TEXT_TYPE.default.type,
    theme: theme,
    color: _constants.greyDark
  }, headingDesktop)), /*#__PURE__*/_react.default.createElement(DesktopInnerWrapper, {
    ref: wrapperRef,
    repeat: repeat,
    isIE: isIE,
    otherTileSelector: otherTileSelector,
    tileItemFlexDirection: tileItemFlexDirection
  }, dataArray.map(function (data) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: data.props.data.productTile
    }, data);
  })))) : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(TextWrapperMobile, null, /*#__PURE__*/_react.default.createElement(_Title.default, {
    type: _constant.TITLE_TYPES.H3,
    theme: theme
  }, headingMobile), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: _constants.CLOSE_ICON,
    fontsize: _constants.ICON_FONT_SIZE,
    color: _constants.greyDark,
    customProperties: iconProperties
  })), /*#__PURE__*/_react.default.createElement(MobileInnerWrapper, {
    tileItemFlexDirection: tileItemFlexDirection
  }, dataArray.map(function (data) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: data.props.data.productTile
    }, data);
  })));
};

ShowAllTiles.propTypes = _showAllTiles.default.PropTypes;
ShowAllTiles.defaultProps = _showAllTiles.default.defaultProps;
var _default = ShowAllTiles;
exports.default = _default;